import { inject, Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { CountryISO } from 'ngx-intl-tel-input';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private readonly API_KEY = 'ira_kqnQEAE7sxRUCKWLlp7hl8G1YPG0GU0yBp6j';
  private readonly API_URL = `https://api.ipregistry.co/?key=${this.API_KEY}`;
  // Same lookup the signup phone field uses to pick its country.
  private readonly GEO_URL = 'https://api.ipgeolocation.io/ipgeo?apiKey=7394c0666cc84f05b9801f43d229666b';

  // HttpBackend skips the auth interceptor, so the session token is never sent to the geo lookup.
  private readonly publicHttp = new HttpClient(inject(HttpBackend));
  private phoneCountry$?: Observable<CountryISO | null>;

  constructor(private http: HttpClient) {}

  /**
   * Get user's country based on IP address
   * @returns Observable with country name or empty string if failed
   */
  async getUserCountry(): Promise<string> {
    try {
      const data: any = await firstValueFrom(this.http.get(this.API_URL));
      return data.location?.country?.name || '';
    } catch (error) {
      return '';
    }
  }

  /**
   * The phone-input country for the user's current location (by IP), or null if it
   * cannot be told. A successful lookup is kept for the session.
   */
  getPhoneCountry(): Observable<CountryISO | null> {
    this.phoneCountry$ ??= this.publicHttp.get<any>(this.GEO_URL).pipe(
      map((data) => {
        const code = String(data?.country_code2 || '').toLowerCase();
        return (Object.values(CountryISO) as string[]).includes(code) ? (code as CountryISO) : null;
      }),
      // A failed lookup is not remembered, so the next form opened tries again.
      catchError(() => {
        this.phoneCountry$ = undefined;
        return of(null);
      }),
      shareReplay(1)
    );
    return this.phoneCountry$;
  }
}
